import { FC } from 'react';
import map from 'lodash/map';
import Item from 'antd/lib/form/FormItem';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import TextArea from 'antd/lib/input/TextArea';
import Select from 'antd/lib/select';

import { shippingPoliciesFields } from 'components/Settings/fieldsConstants';
import ShippingByCountry from 'components/Settings/PoliciesTab/ShippingByCountry/ShippingByCountry';
import { formRules, questionMarks, textareaWithCounterProps } from 'utils/constants/constants';
import { EPoliciesFields } from 'types/settings/enums';
import { IShippingPolicy } from 'types/settings/interfaces';

const { Option } = Select;

const ShippingPolicy: FC<IShippingPolicy> = ({ isShippingError, setIsShippingError }) => (
  <>
    <h4 className="mb-5 mt-2.5">Shipping Policy</h4>
    <Row gutter={20}>
      <Col span={12}>
        {map(shippingPoliciesFields, ({ label, name, component: Component, componentProps, rules, options, tooltip }) =>
          <Item key={name} label={label} name={name} rules={rules} tooltip={tooltip} validateFirst>
            <Component size="large" placeholder={`Enter ${label}`} {...componentProps}>
              {options && map(options, ({ id, description }) => <Option key={id} value={id}>{description}</Option>)}
            </Component>
          </Item>)}
      </Col>
      <Col span={12}>
        <Item
          validateFirst
          rules={[formRules.latinNumberSpecsEnter]}
          name={EPoliciesFields.ShippingDetails}
          label="Shipping Policy Description"
          tooltip={questionMarks.policies.relatedToShipping}
        >
          <TextArea
            placeholder="Enter Shipping Policy Description"
            maxLength={300}
            autoSize={{ minRows: 5, maxRows: 5 }}
            {...textareaWithCounterProps}
          />
        </Item>
      </Col>
    </Row>
    <ShippingByCountry isShippingError={isShippingError} setIsShippingError={setIsShippingError} />
  </>);

export default ShippingPolicy;
